export default __webpack_public_path__ + "static/media/guide.f09aef1e.png";